<template>
  <vx-card no-shadow :style="{ 'pointer-events': __isDisabledSites() ? 'none' : 'auto' }">

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_haccp_system_implemented" name="is_haccp_system_implemented" rules="" v-slot="{ errors }">
              <small class="label">8.1 Is there a fully implemented HACCP system in place for all products?</small>
              <vs-switch v-model="form.is_haccp_system_implemented" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_haccp_system_implemented" vid="is_haccp_system_implemented_text" name="is_haccp_system_implemented_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_haccp_system_implemented_text" class="w-full" v-model="form.is_haccp_system_implemented_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="haccp_team_leader" name="haccp_team_leader" rules="required" v-slot="{ errors }">
              <small class="label">8.2 Who is the HACCP team leader and what training have they received? </small>
              <vs-input type="text" name="haccp_team_leader" class="w-full" v-model="form.haccp_team_leader" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="haccp_review" name="haccp_review" rules="required" v-slot="{ errors }">
              <small class="label">8.3 When was the last HACCP review?</small>
<!--              <vs-input type="date" name="haccp_review" class="w-full" v-model="form.haccp_review"/>-->
<!--              <datepicker name="haccp_review" format="dd/MM/yyyy" v-model="form.haccp_review"></datepicker>-->
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="form.haccp_review"
                placeholder="Choose Date"
              />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="haccp_audits" name="haccp_audits" rules="required" v-slot="{ errors }">
              <small class="label">8.4 How often are HACCP audits carried out? </small>
              <v-select name="haccp_audits" :closeOnSelect="true" v-model="form.haccp_audits" :options="['weekly', 'monthly', 'quarterly', 'half-yearly','yearly']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

<!--        <vs-divider color="primary" border-style="dashed" class="mt-16" position="left">2.3</vs-divider>-->

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_foreign_bodies" name="is_foreign_bodies" rules="required" v-slot="{ errors }">
              <small class="label">8.5 Do you have specific control procedures to prevent contamination from foreign bodies, e.g. metal detectors, sieves?</small>
              <vs-switch v-model="form.is_foreign_bodies" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_foreign_bodies" vid="is_foreign_bodies_text" is_staff_trained_text="is_foreign_bodies_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_foreign_bodies_text" class="w-full" v-model="form.is_foreign_bodies_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_plastic_breakage" name="is_plastic_breakage" rules="" v-slot="{ errors }">
              <small class="label">8.6 Do you have a documented glass/hard plastic breakage procedure?</small>
              <vs-switch v-model="form.is_plastic_breakage" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_plastic_breakage" vid="is_plastic_breakage_text" name="is_plastic_breakage_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_plastic_breakage_text" class="w-full" v-model="form.is_plastic_breakage_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <small class="label">HACCP plan and process flow chart</small>
            <file-uploader
              v-on:onSetFileName="value => form.haccp_plan_process = value"
              v-on:onClickFileRemove="form.haccp_plan_process = null"
              :file="form.haccp_plan_process"
              :condition="true"
            />
<!--            -->
<!--            <ValidationProvider vid="haccp_plan_process" name="haccp_plan_process" rules="" v-slot="{ errors }">-->
<!--              <small class="label">HACCP plan and process flow chart</small>-->
<!--              <a target="_blank" v-if="form.haccp_plan_process" class="float-right" :href="form.haccp_plan_process">view file</a>-->
<!--              <vs-input @change="onUploadFile($event)" type="file" name="haccp_plan_process" class="w-full" />    &lt;!&ndash; enviromental_policy_file &ndash;&gt;-->
<!--              <span v-if="formUploadRequired" class="text-danger text-sm">This field is required</span>-->
<!--            </ValidationProvider>-->
          </div>
        </div>



        <div class="flex flex-wrap items-center justify-end" v-can="'edit-site'">
          <vs-button v-if="status.is_supplier_manufacture_site_haccp_complete === 1"  button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4">Save and Change</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRepository = RepositoryFactory.get('supplier');
  import vSelect from "vue-select";

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          is_haccp_system_implemented: false,
          is_foreign_bodies: false,
          is_plastic_breakage: false
        },
        id: null,
        status: {},
        formUploadRequired: false
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    components: {
      'v-select': vSelect,
      Datepicker,
      flatPickr
    },
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_supplier_manufacture_site_haccp_complete === 1 ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        if (!this.form.haccp_plan_process) {
          this.formUploadRequired = true
        } else {
          this.$vs.loading()
          try {
            const data= (await SupplierManufactureRepository.UpdateManufacturehaccpsDetails(this.id, this.form))
            this.showSuccessMessage('Manufacture HACCP Details Updated!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        }
      },
      async onClickCreate() {
        if (!this.form.haccp_plan_process) {
          this.formUploadRequired = true
        } else {
          this.$vs.loading()
          try {
            const data= (await SupplierManufactureRepository.CreateManufacturehaccpsDetails(this.form))
            this.showSuccessMessage('Manufacture HACCP Details Created!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        }
      },
      async onUploadFile(event) {
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.form.haccp_plan_process = (await SupplierRepository.uploadFile(formData)).data.data.file
          this.formUploadRequired = false
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufacturehaccpsDetails(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureSiteStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_manufacture_site_id =  this.id
      await this.loadStatus()
      if (this.status.is_supplier_manufacture_site_haccp_complete === 1 ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
